import { customMedia, customizeCosmosButtons } from '@space-lib/styles'
import type { ThemeType } from '@space-lib/styles/themes/types'
import { createGlobalStyle, css } from 'styled-components'

import '@hotmart/cosmos/dist/styles/reset.css'
import '@hotmart/cosmos/dist/styles/base.css'
import '@hotmart/cosmos/dist/styles/theme.css'
import '@hotmart/cosmos/dist/grid/grid.css'
import '@hotmart/cosmos/dist/styles/utilities/cursor.css'
import '@hotmart/cosmos/dist/styles/utilities/text/text.css'
import '@hotmart/cosmos/dist/styles/utilities/flex/flex.css'
import '@hotmart/cosmos/dist/styles/utilities/sizing/sizing.css'
import '@hotmart/cosmos/dist/styles/utilities/border/border.css'
import '@hotmart/cosmos/dist/styles/utilities/display/display.css'
import '@hotmart/cosmos/dist/styles/utilities/spacing/spacing.css'
import '@hotmart/cosmos/dist/styles/utilities/text/variations/blue.css'
import '@hotmart/cosmos/dist/styles/utilities/text/variations/grays.css'
import '@hotmart/cosmos/dist/styles/utilities/text/variations/green.css'
import '@hotmart/cosmos/dist/styles/utilities/background/variations/grays.css'
import '@hotmart/cosmos/dist/styles/utilities/background/variations/blue.css'
import '@hotmart/cosmos/dist/styles/utilities/overflow/overflow.css'
import '@hotmart/cosmos/dist/styles/utilities/align.css'

import '@hotmart-org-ca/cosmos-web/dist/web-components/cosmos-web/cosmos-web.css'
import '@hotmart-org-ca/cosmos-tokens/dist/hotmart-product/base/css/_variables.css'

export const GlobalStyle = createGlobalStyle<{ theme: ThemeType }>`
  :root, :host {
    ${({ theme: { colors } }) =>
      css`
        --gray-100: ${colors.gray100} !important;
        --gray-200: ${colors.gray200} !important;
        --gray-300: ${colors.gray300} !important;
        --gray-400: ${colors.gray400} !important;
        --gray-500: ${colors.gray500} !important;
        --gray-600: ${colors.gray600} !important;
        --gray-700: ${colors.gray700} !important;
        --gray-800: ${colors.gray800} !important;
        --gray-900: ${colors.gray900} !important;
        --bg-primary: ${colors.bgPrimary} !important;
        --bg-secondary: ${colors.bgSecondary} !important;
        --structure-menu-bg: ${colors.bgPrimary} !important;
        --structure-menu-box-shadow: none !important;
        --structure-menu-item-color: ${colors.gray900} !important;
        --structure-header-bg: ${colors.bgPrimary} !important;
        --structure-border-width: 0 !important;
        --brand-primary: ${colors.brandPrimary} !important;
        --brand-secondary: ${colors.brandSecondary} !important;
        --modal-background-color: ${colors.bgPrimary} !important;
        --progress-bg: ${colors.progressBg} !important;
        --dropdown-background-color: ${colors.bgPrimary} !important;
        --dropdown-menu-padding: 0 !important;
        --dropdown-menu-width: 22.5rem !important;
        --component-border-color: ${colors.gray200} !important;
        --tooltip-max-width: 18rem !important;
        --modal-close-display: none !important;

        --hc-container-max-width: unset;
        --hc-collapse-padding: 0;
        --hc-collapse-item-content-padding: 0 0 var(--hc-size-spacing-4);
        --hc-collapse-item-header-focus-background-color: ${colors.gray100};

        ${customMedia.lessThan('lg')`
          --dropdown-menu-width: 16.25rem !important;
        `}

        ${customizeCosmosButtons({ colors })}
      `}
  }

  hot-menu-item::part(item):hover {
    background-color: var(--custom-color-lighter)
  }

  body {
    background-color: ${({ theme }) => theme.colors.bgPrimary} !important;
    overflow-y: hidden;

    > #root {
      overflow-y: auto;
    }
  }

  ._font-14 {
    font-size: 0.875rem !important;
  }

  ._font-18 {
    font-size: 1.125rem;
  }

  ._bg-primary {
    background-color: var(--bg-primary) !important;
  }

  ::-webkit-scrollbar {
    width: 0.5rem;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
    height: var(--spacer-2);
    width: var(--spacer-2);
  }

  ::-webkit-scrollbar-thumb {
    background-color: var(--gray-300);
    border-radius: var(--border-radius-sm);
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: var(--gray-400);
  }
`
